export const capitalize = (str: string) =>
  str.replace(/^\w/, (c) => c.toUpperCase());

export const formatNumber = (num: number) =>
  num.toLocaleString('en-US', {
    minimumFractionDigits: num % 1 != 0 ? 2 : undefined,
  });

export const formatDollar = (dollar: number) => `$${formatNumber(dollar)}`;

// NOTE: Should standardize utils across projects
export const centsToDollarString = (cents: number): string =>
  formatDollar(cents / 100.0);
